import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import EditIcon from '@material-ui/icons/Edit';
import UsedRentalsTransportAPI from '../../../../API/UsedRentalsTransportAPI';
import RUTransportsWADTableHeader from './RUTransportsWADTableHeader';
import RUTransportsWADToolbar from './RUTransportsWADToolbar';
import LinearProgress from '../../../Utils/LinearProgress';
import RUTransportsWADForm from './RUTransportsWADForm';
import { FormatDate } from '../../../Utils/GenericFunctions';
import { NO_TABLE_DATA_MESSAGE, STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_ASCENDING } from '../../../../Utils/Constants';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import { handleServerError } from '../../../../Utils/Helper';


const styles = theme => ({
  paperRoot: {
    width: '100%',
    backgroundColor: '#F6F6F6',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  cellPadding: {
    paddingLeft: '6px',
  },
  textCenter: {
    textAlign: 'center',
  },
  tblRow: {
    backgroundColor: '#F2F2F2',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1',
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      },
    },
    height: '30px'
  },
  editWidth: {
    width: '38px'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  tblFooter: {
    height: '30px',
    minHeight: '30px'
  },
  pageButton: {
    width: '30px',
    height: '30px',
    margin: '0px 8px'
  }
});


export class RUTransportsWADTable extends Component {
  searchTimer = null;
  ruTransportAPI;

  constructor(props) {
    super(props);
    this.state = {
      order: ORDER_ASCENDING,
      orderBy: 'customer',
      data: [],
      page: STARTING_TABLE_PAGE,
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      count: 0,
      search: '',
      loading: false,
      openTransportsDialog: false,
      carId: '',
      lotInfo: [],
      openError: false,
      alertMessage: ''
    };
    this.ruTransportAPI = new UsedRentalsTransportAPI();
  }

  componentDidMount() {
    this.reloadTableEdit();
  };

  reloadTableEdit() {
    this.setState({ loading: true });
    this.ruTransportAPI.getRUTransportsCarsWAD(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      this.setState({
        data: response.data.CarList,
        count: response.data.NumberFilteredResults,
        page: STARTING_TABLE_PAGE,
        loading: false
      });
    }).catch((error) => {
      this.setState({
        loading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ loading: true });
    this.ruTransportAPI.getRUTransportsCarsWAD(this.state.page, this.state.rowsPerPage, orderBy, order, this.state.search).then((response) => {
      this.setState({
        data: response.data.CarList,
        count: response.data.NumberFilteredResults,
        order, orderBy,
        loading: false
      });
    }).catch((error) => {
      this.setState({
        loading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleChangePage = (event, page) => {
    this.setState({ loading: true });
    this.ruTransportAPI.getRUTransportsCarsWAD(page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      this.setState({
        data: response.data.CarList,
        count: response.data.NumberFilteredResults,
        page: page,
        loading: false
      });
    }).catch((error) => {
      this.setState({
        loading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ loading: true });
    this.ruTransportAPI.getRUTransportsCarsWAD(this.state.page, event.target.value, this.orderBy, this.order, this.state.search).then((response) => {
      this.setState({
        data: response.data.CarList,
        count: response.data.NumberFilteredResults,
        rowsPerPage: event.target.value,
        loading: false
      });
    }).catch((error) => {
      this.setState({
        loading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  reloadTableBySearch(searchBy) {
    this.setState({ loading: true });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.ruTransportAPI.getRUTransportsCarsWAD(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, searchBy).then((response) => {
        this.setState({
          data: response.data.CarList,
          count: response.data.NumberFilteredResults,
          search: searchBy,
          page: STARTING_TABLE_PAGE,
          loading: false
        });
      }).catch((error) => {
        this.setState({
          loading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      });
    }, 1500);
  };

  handleCloseTransportsDialog = () => {
    this.setState({ openTransportsDialog: false });
  };

  handleClickEdit(transportItem) {
    this.setState({
      openTransportsDialog: true,
      carId: transportItem.L4ID,
      lotInfo: transportItem
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  renderTableRecords(transportList) {
    const { classes } = this.props;

    return transportList.map(transportItem => {
      return (
        <TableRow key={transportItem.L4ID} tabIndex={-1} className={classes.tblRow}>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {transportItem.CarBrand}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {transportItem.CarModel}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {transportItem.ColourDescription}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {transportItem.LicensePlate}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {transportItem.OrderNumber}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {transportItem.OrderStatus}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {transportItem.ClientName}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {transportItem.OriginalLocation}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {transportItem.DestinationLocation}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {FormatDate(transportItem.CustomerExpectedDeliveryDate)}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {FormatDate(transportItem.RequestDate)}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {FormatDate(transportItem.DestinationExpectedDate)}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {FormatDate(transportItem.DestinationArrivalDate)}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {FormatDate(transportItem.EffectiveDeliveryDate)}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {FormatDate(transportItem.ExpectedDeliveryDate)}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.editWidth)} padding='none'>
            <Tooltip title='Editar' placement='bottom' >
              <IconButton aria-label='Edit' onClick={() => this.handleClickEdit(transportItem)} className={classes.buttonSizeTbl} >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      );
    })
  }

  renderNoRecordMessages() {
    return NO_TABLE_DATA_MESSAGE;
  }


  render() {
    const { classes } = this.props;
    const { data, order, orderBy, rowsPerPage, page, count, loading } = this.state;
    return (
      <Paper className={classes.paperRoot}>

        <RUTransportsWADToolbar
          reloadTableBySearch={this.reloadTableBySearch.bind(this)}
          reloadTableEdit={this.reloadTableEdit.bind(this)}
          handleChangeContent={this.props.handleChangeContent.bind(this)}
        />
        <div className={classes.tableWrapper}>
          <Table>
            <TableHead className={classes.tblHead} >
              <RUTransportsWADTableHeader
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
              />
            </TableHead>
            <TableBody>
              {this.renderTableRecords(data)}
            </TableBody>
          </Table>
          {(!data.length) ? this.renderNoRecordMessages() : null}
        </div>
        {loading && <LinearProgress />}
        <TablePagination
          component='div'
          count={count}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          labelRowsPerPage={'Resultados por página:'}
          page={page}
          backIconButtonProps={{ className: classes.pageButton }}
          nextIconButtonProps={{ className: classes.pageButton }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) => `A mostrar resultados ${from}-${to} de ${count}`}
          classes={{ toolbar: classes.tblFooter }}
        />

        <Dialog
          fullScreen
          open={this.state.openTransportsDialog}
          onClose={this.handleCloseTransportsDialog.bind(this)}
        >
          <RUTransportsWADForm
            handleClose={this.handleCloseTransportsDialog.bind(this)}
            carId={this.state.carId}
            lotInfo={this.state.lotInfo}
            reloadTableEdit={this.reloadTableEdit.bind(this)}
          />
        </Dialog>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    );
  }
}

RUTransportsWADTable.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTableBySearch: PropTypes.func
};

export default RUTransportsWADTable = withStyles(styles)(RUTransportsWADTable);


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsTransport/UsedRentalsWaitingArrival/RUTransportsWADTable.js